import { useEffect } from 'react';

const Download = () => {
    useEffect(() => {
        const timer = setTimeout(() => {
            const ua = navigator.userAgent || "";
            const uaData = (navigator as any).userAgentData;


            const isAndroid = /android/i.test(ua) || uaData?.platform?.toLowerCase?.() === "android";
            const isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.includes("Macintosh") && navigator.maxTouchPoints > 2);

            if (isAndroid) {
                window.location.replace("https://play.google.com/store/search?q=mobithera&c=apps");
            } else if (isIOS) {
                window.location.replace("https://apps.apple.com/us/app/mobithera/id6468960239");
            }
            else {
                window.location.replace("https://play.google.com/store/search?q=mobithera&c=apps");
            }
        }, 100);

        return () => clearTimeout(timer);
    }, []);


    return (
        <>
        </>
    );
}

export default Download;
